/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import { useToggle } from "react-use";
import { Button, Loader, ModalConfirm } from "@nordcloud/gnui";
import { generateActionConfirmText, inflect, isEmpty } from "~/tools";
import { useGroupingExport } from "./hooks";

type ExportFilters = Parameters<ReturnType<typeof useGroupingExport>[0]>[0];

type Props = {
  recordsCount: number;
  filters: ExportFilters;
};

export function ExportGroupedResources({ recordsCount, filters }: Props) {
  const [isModalOpen, toggleIsModalOpen] = useToggle(false);
  const [exportGroupedEstates, { loading }] = useGroupingExport();

  const isDisabled =
    recordsCount === 0 ||
    isEmpty(filters.chartJobId) ||
    isEmpty(filters.startDate) ||
    isEmpty(filters.endDate);

  return (
    <>
      <Button
        icon="download"
        severity="medium"
        disabled={isDisabled}
        css={{ textTransform: "none" }}
        onClick={toggleIsModalOpen}
      >
        Export to CSV
      </Button>
      <ModalConfirm
        isOpen={isModalOpen}
        actionLabel="Export"
        contentLabel="Export Estate Records"
        confirm={() => {
          void exportGroupedEstates(filters);
          toggleIsModalOpen();
        }}
        onClose={toggleIsModalOpen}
      >
        <When condition={loading}>
          <Loader inContent />
        </When>
        Export generation process is going to take some time and the result file
        will be delivered to your email. <br />
        {generateActionConfirmText(
          `${recordsCount} ${inflect("record")(recordsCount)}`
        )("export")()}
      </ModalConfirm>
    </>
  );
}
